import { InformationCircleIcon } from '@heroicons/react/outline';
import Link from 'next/link';

import HELP_ROUTES from '@/utils/HelpRoutes';

const getHelpRoute = (help) => {
  let links = [];
  HELP_ROUTES.forEach((section) => (links = [...links, ...section.links]));
  const link = links.filter((link) => link.help === help)[0];
  return link ? link.href : '/docs';
};

export default function HelpIconButton({ help = 'intro' }) {
  const linkToHelp = getHelpRoute(help);
  return (
    <span className="mx-1 my-auto">
      <Link href={linkToHelp} target="_blank">
        <InformationCircleIcon className="h-5 w-5"></InformationCircleIcon>
      </Link>
    </span>
  );
}
